import PrivacyPolicyMain from './Main/PrivacyPolicyMain';

import styles from './styles.module.scss';

export async function generateMetadata() {
  return {
    title: 'Privacy — JAECOO',
    description:
      'Explore our privacy policy. Find out what personal data we collect, how we use and protect it, with whom we share it, and what rights you have.',
  };
}

export default function PrivacyPolicy({ fields }) {
  return (
    <div>
      <h1 className={styles.title}>
        <b>{fields.title.value}</b>
      </h1>
      <PrivacyPolicyMain fields={fields} />
    </div>
  );
}
